module.exports = __webpack_public_path__ + "img/li.b727ba5f.svg";